import { registerFeatureMessages, type SupportedLocale } from '@/shared/i18n'

/**
 * Merges `features/workspace-definitions/i18n/<locale>.json` under the `workspaceDefinitions`
 * namespace. English only: the orphan Turkish catalog was deleted (it outlived ORP-19869's
 * sweep) — never add `tr.json`.
 */
export function registerDefinitionsMessages(locale: SupportedLocale): Promise<void> {
  return registerFeatureMessages('workspaceDefinitions', locale)
}
